import * as api from '../../api/api-provision-gastos';
import { 
    GET_CONFIG_FORM34,
    GET_GASTOS_GRILLA
  
    
} from '../types';

export const configuracionFormAction34 = (query) => ({
    type: GET_CONFIG_FORM34,
    payload: api.getConfiguracionForm34(query)
});
export const obtenerGastosGrilla = (query) => ({
    type: GET_GASTOS_GRILLA,
    payload: api.getGastosGrilla(query)
});
